import { render, staticRenderFns } from "./Amenities.vue?vue&type=template&id=a6fa5198"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports